<script setup>
  import { ref, computed, onMounted } from 'vue';
  import { useSpotStore } from '@/stores/SpotStore';
  import { useProForecastStore } from '@/stores/ProForecastStore';
  import { useUserStore } from '@/stores/UserStore'
  import useLegacyBridge from "@/composables/useLegacyBridge";

  const model = defineModel();
  const ncWindDataEnabled = defineModel('ncWindDataEnabled');  

  const props = defineProps({
    isNCWind: {
      type: Boolean,
      required: true
    }
  });

  const spotStore = useSpotStore();
  const proForecastStore = useProForecastStore();
  const userStore = useUserStore();

  const { basicGraph } = useLegacyBridge();
  
  const graphContainer = ref(null);
  const modelSelectorContainer = ref(null);
  const footerContainer = ref(null);

  const showProForecastModel = computed(() => spotStore.proForecastIdIfExists && spotStore.hasSpotProduct(3) && proForecastStore.canShowProForecast);
  const proForecastModelId = computed(() => spotStore.proForecastIdIfExists);

  const getProForecastModel = async () => {
    let spotForecastModelData = null;

    if (userStore.memberLevel >= 49) {
      await proForecastStore.getProForecast(proForecastModelId.value);
      spotForecastModelData = proForecastStore.buildSpotForecastModelData(spotStore.spotId, spotStore.localUTCOffset);
    }

    if (!spotForecastModelData) {
      console.warn("No Pro Forecast Model Data available");
      return spotForecastModelData;
    }

    return {
      is_premium: true,
      is_pro_only: true,
      model_name: 'Pro Forecast',
      model_id: -9999,
      model_color: '513A85',
      model_data: spotForecastModelData,
      is_upgrade_available: userStore.memberLevel < 49,
    }
  };
  
  const loadGraph = async () => {
    const settings = {
      showModelData: true,
      showModelSelector: true,
      modelData: {...spotStore.forecastModelData},
      modelSelectorTarget: modelSelectorContainer.value,
      legendTarget: footerContainer.value,
      spotId: spotStore.spotId,
      favSpotId: spotStore.spotFavoriteId,
      lat: spotStore.lat,
      lon: spotStore.lon,
      type: 'detail',
      zoom: 11,
      isNCWind: props.isNCWind,
			ncWindDataEnabled: ncWindDataEnabled.value
    }       

    if (showProForecastModel.value) {
      const proForecastModelData = await getProForecastModel();

      if (proForecastModelData) settings.additionalModels = [proForecastModelData];
    }
    
    model.value = basicGraph(graphContainer.value, settings);
  }

  onMounted(() => loadGraph())  
</script>

<template>
  <div
    class="jwx-data-container__scrolling-submenus jw-model-selector-container"
    ref="modelSelectorContainer"
  ></div>
  <div
    class="jwx-data-container__content"
    style="width: 100%; min-height: 386px;"
    ref="graphContainer"
  ></div>
  <div
    class="jwx-data-container__footer jw-graph-legend-container jw-graph-legend"
    ref="footerContainer"
  ></div>
</template>